import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Serzh | Frontend', // e.g: 'Name | Developer'
  lang: 'ru', // e.g: en, es, fr, jp
  description: 'frontend developer', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Serzhan',
  subtitle: "I'm  frontend developer.",
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'aboutme.webp',
  paragraphOne:
    "Hello, I'm Serzhan, from Kazakhstan. I've been learning front-end development since last year. Very excited to learn, develop my skills and knowledge in this fast-changing web world :)",
  paragraphTwo:
    'Привет! Меня зовут Сержан, я из Казахстана. Изучаю фронтенд больше года. Всегда рад учится полезным навыкам и расширять знания в этом прогрессивном мире веба :)',
  paragraphThree: ' ', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'judge-devs.png',
    title: 'Place, where devs share projects',
    info: 'Website, where developers can share their projects. It is like extended README from github.',
    info2: 'Technologies: Next13, trpc, postgres, Chakra UI, react-query',
    url: 'https://judge-devs.vercel.app/',
    repo: 'https://github.com/serzhan181/judge-devs',
  },
   {
    id: nanoid(),
    img: 'project-4.png',
    title: 'Reclone',
    info:
      'The app is intented to be a clone of reddit',
    info2: 'Technologies: Nextjs, Nestjs, typeorm, postgresql, react-query, tailwindcss',
    url: 'https://reclone.vercel.app/',
    repo: 'https://github.com/serzhan181/reclone/tree/delta', // if no repo, the button will not show up  
  },
  {
    id: nanoid(),
    img: 'project-1.png',
    title: 'Sound Enjoy',
    info: 'Music player.',
    info2: 'Technologies: Next, tailwindcss',
    url: 'https://soundenjoy.vercel.app',
  },
  {
    id: nanoid(),
    img: 'project-2.png',
    title: 'Movie app',
    info:
      'Here you can search for primary data about movies, see the ratings, create articles in article section, read and rate them and comment on them.',
    info2: 'Technologies: React, react-router, mobx, express, typeorm, postgresql.',
    url: 'https://movie-opal.vercel.app/',
    repo: 'https://github.com/serzhan181/Movie', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'serzhan181@outlook.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'telegram',
      url: 'https://t.me/serbaevvv',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/serzhan181',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
